import React, { useState } from 'react';
import { Button, Typography, MuiBox, SvgIcon, color } from '@kis-technologies/kis-ui';
import { useActions } from 'hooks/useActions';
import { actions as kiosksActions, Kiosk, selectors as kiosksSelectors } from 'store/kiosks';
import { useSelector } from 'react-redux';
import { useStyles } from '../styled';

import { KioskHardwareStatus } from './KioskStatus';

export interface KioskHardwareProps {
  kiosk: Kiosk;
}

const KioskHardware = (props: KioskHardwareProps) => {
  const { kiosk } = props;
  const { getKiosk } = useActions({ getKiosk: kiosksActions.getKiosk });
  const { pending: kioskPending } = useSelector(kiosksSelectors.selectAction);
  const [showKioskHardware, setShowKioskHardware] = useState<boolean>(false);

  const onStatusClick = () => {
    getKiosk({ kioskId: kiosk.id });
    if (!kioskPending) setShowKioskHardware(true);
  };

  const onClose = () => {
    setShowKioskHardware(false);
  };
  const classes = useStyles({ showDrawer: showKioskHardware })();
  return (
    <>
      <div className={classes.kioskStatusRow}>
        {kiosk.online ? (
          <Button
            onClick={onStatusClick}
            className={kiosk.status === 'Active' ? classes.activeStatusButton : classes.inactiveStatusButton}
          >
            <SvgIcon name="circle" size={15} style={{ width: '30px' }} />
            {kiosk.status}
          </Button>
        ) : (
          <MuiBox className={classes.offlineStatusBox}>
            <SvgIcon name="circle" size={15} style={{ width: '30px' }} color={color.RED} />
            <Typography fontSize={16} fontWeight={600} color={color.RED}>
              Offline
            </Typography>
          </MuiBox>
        )}
      </div>
      {/* Drawer as seperate component to avoid showing popup view instead of sliding */}
      {showKioskHardware && <KioskHardwareStatus onClose={onClose} isOpen={showKioskHardware} kiosk={kiosk} />}
    </>
  );
};

export default KioskHardware;
